import gql from 'graphql-tag';

export const UPLOAD_STATUS_QUERY = gql`
  query uploadStatus($userId: String, $organisationId: String, $status: [UploadStatusGroup], $operationToken: String, $createdAfter: String, $createdBefore: String, $cursor: String, $limit: Int) {
    uploadStatus(userId: $userId, organisationId: $organisationId, status: $status, operationToken: $operationToken, createdAfter: $createdAfter, createdBefore: $createdBefore, cursor: $cursor, limit: $limit) {
      uploads {
        operationToken
        trintId
        status
        state
        subState
        filename
        language
        createdAt
        updatedAt
        completedAt
        errorCode
        errorMessage
      }
      pagination {
        nextCursor
        hasMore
      }
    }
  }
`;

export const UPLOAD_STATUS_SUMMARY_QUERY = gql`
  query uploadStatusSummary($userId: String, $organisationId: String, $status: [UploadStatusGroup], $createdAfter: String, $createdBefore: String) {
    uploadStatusSummary(userId: $userId, organisationId: $organisationId, status: $status, createdAfter: $createdAfter, createdBefore: $createdBefore) {
      pending
      importing
      processing
      ready
      failed
    }
  }
`;
